export default class ModalInformationAdminPreview extends HTMLDivElement {

    constructor() {
        super();
    }

    connectedCallback() {
        var modal = document.getElementById('modal-information-preview');
        var myModal = new bootstrap.Modal(modal, {
            keyboard: false,
            backdrop:"static"
        });
        myModal.show()
    }
}